import { Injectable, signal, computed } from '@angular/core';

const STORAGE_KEY = 'IRMA_STUDIO_SETTINGS';

@Injectable({ providedIn: 'root' })
export class SettingsService {
  private readonly settingsSignal = signal<Record<string, unknown>>({});
  readonly settings = computed(() => this.settingsSignal());

  constructor() {
    this.loadSettings();
  }

  get<T = unknown>(key: string): T | null {
    return (this.settingsSignal()[key] as T) ?? null;
  }

  set<T = unknown>(key: string, value: T): void {
    this.settingsSignal.update(current => ({ ...current, [key]: value }));
    this.persist();
  }

  remove(key: string): void {
    this.settingsSignal.update(current => {
      const { [key]: _, ...rest } = current;
      return rest;
    });
    this.persist();
  }

  clear(): void {
    this.settingsSignal.set({});
    try { localStorage.removeItem(STORAGE_KEY); } catch { /* noop */ }
  }

  private loadSettings(): void {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) this.settingsSignal.set(JSON.parse(stored));
    } catch {
      this.settingsSignal.set({});
    }
  }

  private persist(): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.settingsSignal()));
    } catch { /* noop */ }
  }
}

export const SETTINGS_KEYS = { AUTH_USER: 'authUser', RAIL_EXPANDED: 'railExpanded' } as const;
